import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

export interface ModalLoaderState {
  ids: string[]
}

export const initialState: ImmutableGenericType<ModalLoaderState> = Immutable({
  ids: ['appInitModalLoader'],
})
